export default {
  categories: [],
  menuCategories: [],
  isModalOpen: false,
  isSubCategoryModalOpen: false,
  categoryToUpdate: {
    id: null,
    name: '',
    order: null,
    subCategories: [],
    showOnMenu: true,
  },
  categoryId: '',
  subCategoryToUpdate: {
    id: null,
    name: '',
    order: null,
  },
  categoryItemsToUpdateOrder: [],
  subCategoryItemsToUpdateOrder: [],
};
